import autosize from "autosize";

document.addEventListener("DOMContentLoaded", function () {
	const horizontalTabs = document.querySelector(".horizontal-tabs");

	if (horizontalTabs) {
		const tabsButtons = document.querySelectorAll("[data-tab-button]");
		const tabsPanels = document.querySelectorAll("[data-tab-panel]");
		const subPanels = document.querySelectorAll("[data-tab-sub-panel]");
		const innerTabsButtons = document.querySelectorAll("[data-inner-tab-button]");
		const innerTabsPanels = document.querySelectorAll("[data-inner-tab-panel]")

		// Обработка хэша при загрузке страницы
		if (document.location.hash) {
			const hashTarget = document.location.hash.slice(1);

			tabsButtons.forEach((button) => {
				button.dataset.tabButtonState = button.dataset.tabButton === hashTarget ? "active" : "";
			});

			tabsPanels.forEach((panel) => {
				panel.dataset.tabPanelState = panel.dataset.tabPanel === hashTarget ? "active" : "";
			});

			subPanels.forEach((panel) => {
				panel.dataset.tabPanelState = panel.dataset.tabSubPanel === hashTarget ? "active" : "";
			});
		}

		// Обработка кликов по кнопкам вкладок
		tabsButtons.forEach((button) => {
			button.addEventListener("click", function () {
				const tabButtonTarget = button.dataset.tabButton;

				// Сброс состояния кнопок и панелей
				tabsButtons.forEach((btn) => (btn.dataset.tabButtonState = ""));
				tabsPanels.forEach((panel) => {
					panel.dataset.tabPanelState = panel.dataset.tabPanel === tabButtonTarget ? "active" : "";

					// обновление высоты полей textarea для страницы Готовим кадры
					const panelsTextarea = panel.querySelectorAll('textarea')

					if (panelsTextarea.length > 0) {
						autosize(panelsTextarea)
						autosize.update(panelsTextarea);
					}
				});

				if (subPanels.length > 0) {
					subPanels.forEach((panel) => {
						panel.dataset.tabPanelState = panel.dataset.tabSubPanel === tabButtonTarget ? "active" : "";
					});
				}

				// Установка активного состояния
				button.dataset.tabButtonState = "active";
				document.location.hash = tabButtonTarget;
			});
		});

		if (innerTabsButtons.length > 0) {
			//обработка клика по внутренним табам
			innerTabsButtons.forEach((button) => {
				button.addEventListener('click', () => {
					const tabButtonTarget = button.dataset.innerTabButton;

					innerTabsButtons.forEach((btn) => (btn.dataset.innerTabButtonState = ""));
					innerTabsPanels.forEach((panel) => {
						panel.dataset.innerTabPanelState = panel.dataset.innerTabPanel === tabButtonTarget ? "active" : "";
					})

					button.dataset.innerTabButtonState = "active";
				})
			})
		}
	}
});
